import React from 'react';

export const pageMeta = {
  "name": "JS Chart.js",
  "link": "/javascript/graphics/chartjs"
};

export default function JavascriptGraphicsChartjs() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Chart.js</h2>
      <p>Route: /javascript/graphics/chartjs</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
